import React from 'react';

const NoResults = props => (
  <div className="container-no-notifs">
    <div>
      <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12P4zwAAAgEBAKrChTYAAAAASUVORK5CYII=" alt="" className="transparent-img"/>
      <img src={require("../../img/icon-no-notif.svg")} alt="" className="icon-no-notif"/>
    </div>
    <span>{props.text}</span>
  </div>
);

export default NoResults;



// WEBPACK FOOTER //
// ./src/components/notices/NoResults.js